
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexuRJzoj5ENo46k632NM26hDukKUAlbeU8Gpo9ny_45yrh8Meta } from "/opt/build/repo/pages/hub/index.vue?macro=true";
import { default as suspendedsEU2qvBQddSkwdtJf7ahl_45IxSmzjOW6VW7Dw8oT2Ni0Meta } from "/opt/build/repo/pages/hub/suspended.vue?macro=true";
import { default as indexvKPPGPyr_guk0IVYXGxgb1nU8ZiH_OI_45VVyI8xvxIvwMeta } from "/opt/build/repo/pages/hub/account/index.vue?macro=true";
import { default as index9ICLOfg7B7amsMhTcN4j_OvHCli5DTLCYi_ltn1tIkYMeta } from "/opt/build/repo/pages/hub/clients/index.vue?macro=true";
import { default as indexI_45_P6dm0_456qcvZVG_45bPneLY_6HAIailMPWKraGPWCMQMeta } from "/opt/build/repo/pages/hub/sessions/index.vue?macro=true";
import { default as indexoEgaBwvvnutiRni0n9DxaO2A56AexhITapcprCku4LQMeta } from "/opt/build/repo/pages/hub/sessions/create/index.vue?macro=true";
import { default as edittCNxJTZeLAJ22j52orsRahmokp9aQ9XjQ0lNF0e87dgMeta } from "/opt/build/repo/pages/hub/clients/[client_id]/edit.vue?macro=true";
import { default as editV_Yd9cIh4wQrIXe0x0XAZx_EpGtqP4bFfPz13jwhV_45UMeta } from "/opt/build/repo/pages/hub/sessions/[session_id]/edit.vue?macro=true";
import { default as _91invoice_id_93Yw_45fwa6KfYFBVd4p7VOV7DhhCFtG7hCVVonKCSg3XcMMeta } from "/opt/build/repo/pages/hub/account/invoices/[invoice_id].vue?macro=true";
import { default as documentsIZepVEPJ16bnbEsSitC4pVuq81ONY1kG9HfCy6gi2EEMeta } from "/opt/build/repo/pages/hub/sessions/create/[session_id]/documents.vue?macro=true";
import { default as participantsY2gE5VLn8XqvI5AphdFKKgcw14403radM1qSQcK7bTYMeta } from "/opt/build/repo/pages/hub/sessions/create/[session_id]/participants.vue?macro=true";
import { default as hubmNiv2cv4u1_oKaBSzPzbCPBH9RJ9KB2VhDNzafiPAfIMeta } from "/opt/build/repo/pages/hub.vue?macro=true";
import { default as indexaAs6F0uOO1PbNxqH8DD_45e04gSZQCarVD9TCXJYV94KEMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as index6KQYwgCt1bTcRoYAAw64KdwsuCkHaNYI9qRHwfpdOpQMeta } from "/opt/build/repo/pages/login/index.vue?macro=true";
import { default as oauthSX9eDY39UBORomKrrZzipex62cw5B6akB1H1HP4iFt4Meta } from "/opt/build/repo/pages/login/oauth.vue?macro=true";
import { default as select_45oauthVWo21jhGfESXhPONAabowj4dMEqh4lWi34zDLAlbmZsMeta } from "/opt/build/repo/pages/login/select-oauth.vue?macro=true";
import { default as password_45resetqOut8h6ALHg0APwIUPE_w7Oyccu0Fb6WYL4NkjDWbB4Meta } from "/opt/build/repo/pages/login/password-reset.vue?macro=true";
import { default as logindGU_Y4tTcWsCg9HnKfbgxniTJNnqn8Xqf4N3mbSf_459QMeta } from "/opt/build/repo/pages/login.vue?macro=true";
import { default as indextXLW_dFSGz_9a3jkVO90qLt_uAi4pnbXFWbQLtlLJ_45MMeta } from "/opt/build/repo/pages/invite/index.vue?macro=true";
import { default as oauthDCMwZQAzdz07_458boGPq332Rb6juKbqZLL2WUlUlDX1wMeta } from "/opt/build/repo/pages/invite/oauth.vue?macro=true";
import { default as select_45oauth_45Xv_45LPQ7xmh4A6Tx_xRWPGZPxiFA2iOPLw4xa5dhOMUMeta } from "/opt/build/repo/pages/invite/select-oauth.vue?macro=true";
import { default as inviteWTVDyqcmIHtlgmEznuu6azMupVUNcfFh5sgHx2EV1IEMeta } from "/opt/build/repo/pages/invite.vue?macro=true";
import { default as switch_45n0bdRXGEX5fzYjsHszhhVmTx7gzGHJQpz1wJ_45uEVHQMeta } from "/opt/build/repo/pages/switch.vue?macro=true";
import { default as indexSl0IssOD6uDAvLb3_45PAwS0iJP9J0QLhAFbtCgOMGgn8Meta } from "/opt/build/repo/pages/records/texas/index.vue?macro=true";
import { default as create95T2MaEwas7Ob75YRs8k0pelWiN3ges5VyNb8YA21_MMeta } from "/opt/build/repo/pages/records/texas/create.vue?macro=true";
import { default as index9E9n5O9FqIzgsX9WS575OCMURXALA_UuX_45Lq37t33rgMeta } from "/opt/build/repo/pages/records/alabama/index.vue?macro=true";
import { default as indexHZfv9EzqOpitMeUkDeFbbVPWc3cX0ldiw7ab5bbLzGgMeta } from "/opt/build/repo/pages/records/florida/index.vue?macro=true";
import { default as index2o_Oy_45fcp15C_458uHVJjxqfj7DNgAIbGV14hTD389wDwMeta } from "/opt/build/repo/pages/records/georgia/index.vue?macro=true";
import { default as create6jgrO8IiduLsUt7fJyiodD2GnzsTOhGwVOdf8qCONG8Meta } from "/opt/build/repo/pages/records/alabama/create.vue?macro=true";
import { default as createzPSRpU15yNNvKkLIL5KGH4PIdYp5895Iw8qlzNmi5MQMeta } from "/opt/build/repo/pages/records/florida/create.vue?macro=true";
import { default as createqlnuVhBIQrs56hSiSqPVniXDIv3IMP1dZu0wlFYLAyUMeta } from "/opt/build/repo/pages/records/georgia/create.vue?macro=true";
import { default as indexr4WgwGPVkoLEvejHlpRDTx71RfkQdiZo_45oEfBJMbPdEMeta } from "/opt/build/repo/pages/records/illinois/index.vue?macro=true";
import { default as indexySIo6uGiHw0c_45U3P0hyTIEJ8ZFtUqV3a9fKHcpAWpMAMeta } from "/opt/build/repo/pages/records/new-york/index.vue?macro=true";
import { default as indexoy8hMpFkQbVxezkwtiD8ESGqqZ3gcRhwTtuUvOe2wRwMeta } from "/opt/build/repo/pages/records/virginia/index.vue?macro=true";
import { default as createRD9VD3q_45wmlz0pwJyhSb5ZBJSdsAuXSBvOcMmNtChJEMeta } from "/opt/build/repo/pages/records/illinois/create.vue?macro=true";
import { default as creategKZmyaJadtp0r8bS_45pFg6p3BYwPiG3Joij9947Tlu8wMeta } from "/opt/build/repo/pages/records/new-york/create.vue?macro=true";
import { default as indexwraGnHrpZ47VywK8_TigvLxxXqZ8XSjUzSAxNu3po_45kMeta } from "/opt/build/repo/pages/records/tennessee/index.vue?macro=true";
import { default as createwGBdot9ka2wMzMBV_45VF63pYVQ_RgIjO1KW7s8U55oZ0Meta } from "/opt/build/repo/pages/records/virginia/create.vue?macro=true";
import { default as indexwa70T5on_UVMa1IUOdxRQ7aSg2RU9A4TRn_45NuNz_jy4Meta } from "/opt/build/repo/pages/records/new-jersey/index.vue?macro=true";
import { default as createISySZOmBoQkf6C_VjgP1CuuY4KWAFvcH4DQfaKzLwBgMeta } from "/opt/build/repo/pages/records/tennessee/create.vue?macro=true";
import { default as index_45253olsAPpqKAziYhNXpb5peh34kGUnvXCWlEooftqkMeta } from "/opt/build/repo/pages/records/mississippi/index.vue?macro=true";
import { default as createJPAyqh8NMjUlkWEKzHt9t47NFs_ESRPur61la5TS4LYMeta } from "/opt/build/repo/pages/records/new-jersey/create.vue?macro=true";
import { default as createjK65T_cBNcLSt_45Xtsm1hb_eZ2oI_DY4qK48sSaRR5r8Meta } from "/opt/build/repo/pages/records/mississippi/create.vue?macro=true";
import { default as editoAQZ1HjyqNinSCLimi0oQuEQdmj5q0GnEm_45D2Aa8tvAMeta } from "/opt/build/repo/pages/records/texas/[record_id]/edit.vue?macro=true";
import { default as editItKNiPCl7Dxzi2diKSG8nlow3ue_45EA8jzvFgiQGUoosMeta } from "/opt/build/repo/pages/records/alabama/[record_id]/edit.vue?macro=true";
import { default as editaFMJwUMDJXQ4zaLM7xWwnwRa3fbstqKecBeNVBPByycMeta } from "/opt/build/repo/pages/records/florida/[record_id]/edit.vue?macro=true";
import { default as editgK7gsL1jV378x_mPzdo4ThKu510ISE3nDj9xPi3byOAMeta } from "/opt/build/repo/pages/records/georgia/[record_id]/edit.vue?macro=true";
import { default as editZW5Jp66Lj8e2mbtKZP4_450Ch3daFJKKaR9F21CbXilg4Meta } from "/opt/build/repo/pages/records/illinois/[record_id]/edit.vue?macro=true";
import { default as editsf8b_45Iaicl0Hw8ZkYx_45PCXBjVifuuaxSU32pVuV5ZgMMeta } from "/opt/build/repo/pages/records/new-york/[record_id]/edit.vue?macro=true";
import { default as edit_bpHLOY6jMwakvJ67oYkq_lWOvzm1M6ZbR0iL39IHF4Meta } from "/opt/build/repo/pages/records/virginia/[record_id]/edit.vue?macro=true";
import { default as edit_459E3sCtN6gXZruRJciNmbxMYmFYgwt6niXB9DNk4awQMeta } from "/opt/build/repo/pages/records/tennessee/[record_id]/edit.vue?macro=true";
import { default as editcrGV8jxOzrWLKedQ_45eHHtHA3dnC_3bsUmZMrGVpo4zEMeta } from "/opt/build/repo/pages/records/new-jersey/[record_id]/edit.vue?macro=true";
import { default as edithzZpBtZmtkgWEsWbfiCtDSX9m1IpM47_45L816J3dh1Z8Meta } from "/opt/build/repo/pages/records/mississippi/[record_id]/edit.vue?macro=true";
import { default as recordsx0LcFab84A3DhY1vsDcEOIN0U3_45wIg6nEb5NYfNoTTUMeta } from "/opt/build/repo/pages/records.vue?macro=true";
import { default as indexAv7N_GC9_wZAErchdYW2102WxkHu36pGyLXcYB_vSl8Meta } from "/opt/build/repo/pages/register/index.vue?macro=true";
import { default as detailsB8WUJK1XpcRjoSn_BEYsgxChFjuwC5k97okamRyl3jgMeta } from "/opt/build/repo/pages/register/details.vue?macro=true";
import { default as password_45_hTiOuEgHswyAV4SXXfmO4h7MegUpcdpk8VoFC0v7IMeta } from "/opt/build/repo/pages/register/password.vue?macro=true";
import { default as verificationJ_45agRQ8Cq8OJJlmOxRwp1H6yuVT8Mpq_UMBZOMHmlT0Meta } from "/opt/build/repo/pages/register/verification.vue?macro=true";
import { default as acknowledgment_vmXc_woHYfEQOWL0lZpxMV7L03pSCi8PBOfBX0xsP0Meta } from "/opt/build/repo/pages/register/acknowledgment.vue?macro=true";
import { default as registereUFPUgCXbUbkM74KdKqZIrJcc_QOIXBANMYTn5YpRlAMeta } from "/opt/build/repo/pages/register.vue?macro=true";
import { default as index6RX3n4Mh8_45tuXj_7f6_45m1k4cTd0JZ7DHf09neFWItBsMeta } from "/opt/build/repo/pages/sessions/index.vue?macro=true";
import { default as edit7A_45fGA5qyLcQrZAmk9YC36AewMFRuhgVVlXyZ_1SLN8Meta } from "/opt/build/repo/pages/sessions/[id]/documents/edit.vue?macro=true";
import { default as roomhttqjr1INYSieHwC6W9J0fKjGR54_45sMge1j0le_45muRQMeta } from "/opt/build/repo/pages/sessions/[id]/host/[user_id]/room.vue?macro=true";
import { default as roomv5RKVgCdE_45ejKcD_jwKAw8aekJdIRfLHZx956FcwI7MMeta } from "/opt/build/repo/pages/sessions/[id]/team/[user_id]/room.vue?macro=true";
import { default as kbagzQcUza1D90Oh2P36O5oNCbsivtEZpTWP3LSFVFr9e0Meta } from "/opt/build/repo/pages/sessions/[id]/client/[user_id]/kba.vue?macro=true";
import { default as indexuXMimp7AT5M_45f9YQ5urTDtoe5S4_TN4cfRfpS3d88ZUMeta } from "/opt/build/repo/pages/sessions/[id]/host/[user_id]/index.vue?macro=true";
import { default as indexnKNhax1Rn_45sQHZY9KOwbSmxz88o2SSyr6s859NaCHrAMeta } from "/opt/build/repo/pages/sessions/[id]/team/[user_id]/index.vue?macro=true";
import { default as auths63Np8Gd_458YZIM_UKW7tVv6Iz1HDtusy9QFlv3HhfP4Meta } from "/opt/build/repo/pages/sessions/[id]/client/[user_id]/auth.vue?macro=true";
import { default as roomT7cNFBfaMIUG5xVqO4J3pu_45i7BqOnlY5PcP2fFcTl0kMeta } from "/opt/build/repo/pages/sessions/[id]/client/[user_id]/room.vue?macro=true";
import { default as kbaeH9jacoI0GfsVk4bNRziw5KBblINwoCyjgTgwqZW4ToMeta } from "/opt/build/repo/pages/sessions/[id]/witness/[user_id]/kba.vue?macro=true";
import { default as index6gJawRqYwfEN09GDl3iP_0JhPmQT_5gYmP5kuSgylOwMeta } from "/opt/build/repo/pages/sessions/[id]/client/[user_id]/index.vue?macro=true";
import { default as authdiyHRGOVfnfeCCYMln3_KvATJ4gJ_5_45TIWq4cJQuX9QMeta } from "/opt/build/repo/pages/sessions/[id]/witness/[user_id]/auth.vue?macro=true";
import { default as roomuRNvYFLVw5LIV8s_45DRIdkZbe_45ngqgOprzcDOMqenmsEMeta } from "/opt/build/repo/pages/sessions/[id]/witness/[user_id]/room.vue?macro=true";
import { default as denied2LGeVXEEmP02WHf0NLJ_45r_OWewVEuJzyAlLheRLtRh0Meta } from "/opt/build/repo/pages/sessions/[id]/client/[user_id]/denied.vue?macro=true";
import { default as switchq2KVdjTKVr3dIHuK4ld2ig_G_IJsyrCUuwmLWf7o_45jAMeta } from "/opt/build/repo/pages/sessions/[id]/client/[user_id]/switch.vue?macro=true";
import { default as index011fQnmsho7PF74VrZW1CFmlsfYRXQdunP3HNmRQG74Meta } from "/opt/build/repo/pages/sessions/[id]/witness/[user_id]/index.vue?macro=true";
import { default as roomRO7RvqCyobuvJT4SlXIZuj_PXZ2fsPdKFNv1R22Ti8MMeta } from "/opt/build/repo/pages/sessions/[id]/associate/[user_id]/room.vue?macro=true";
import { default as detailspSqytjV93raQ5IDbMQ4spgB_45cD_45Tdwnht5mkDgd2vdsMeta } from "/opt/build/repo/pages/sessions/[id]/client/[user_id]/details.vue?macro=true";
import { default as previewjFAbGSlM9HWf76cfOZhOGActzuPTz2P6qa6vWcrxcJUMeta } from "/opt/build/repo/pages/sessions/[id]/client/[user_id]/preview.vue?macro=true";
import { default as deniedSsj1W_GoxNnjV01s_45EYHwLKvoaT4zUfWyz16WYG9ZCMMeta } from "/opt/build/repo/pages/sessions/[id]/witness/[user_id]/denied.vue?macro=true";
import { default as indexLXQl5uheEhVVWovXEur3OeSkBw6tT2oTRJ2Z8KA5BqYMeta } from "/opt/build/repo/pages/sessions/[id]/associate/[user_id]/index.vue?macro=true";
import { default as downloadHWJYHqLU2nl_454_4584SYAy0EAbZvj6iCjutgxwlH0KXzEMeta } from "/opt/build/repo/pages/sessions/[id]/client/[user_id]/download.vue?macro=true";
import { default as detailsdLomsDGdtZJ5ib_BEE1_45TWnHRSbvNLQgy5B9veBwO4UMeta } from "/opt/build/repo/pages/sessions/[id]/witness/[user_id]/details.vue?macro=true";
import { default as questionsu6wyXpRQEgNBYZVCq7Bfu1Af6_1SLkQrtgWbxLaGrQoMeta } from "/opt/build/repo/pages/sessions/[id]/client/[user_id]/questions.vue?macro=true";
import { default as detailsrwFRO2_455OTkrns6fDhUZVWEBJCWqpBVLDl1hh8wTe1UMeta } from "/opt/build/repo/pages/sessions/[id]/associate/[user_id]/details.vue?macro=true";
import { default as waiting_45roomvfPX5cUAMpyWpAARToJ7A0odev8aGtvuOj9x1D6tbvoMeta } from "/opt/build/repo/pages/sessions/[id]/team/[user_id]/waiting-room.vue?macro=true";
import { default as waiting_45roomgfjdJs0zrGXmfjVPS7Ex_45iwRqfcvQh_4KxF2n25T4UoMeta } from "/opt/build/repo/pages/sessions/[id]/client/[user_id]/waiting-room.vue?macro=true";
import { default as waiting_45room6D4vwQUYF86PqHH8XyPo3UE8SN7PqqiKW6fvesj_45Y_UMeta } from "/opt/build/repo/pages/sessions/[id]/witness/[user_id]/waiting-room.vue?macro=true";
import { default as waiting_45roompKoUrdh7A9YmSC7qTQ_nCUhgozYyvFNwMewM4NptVZcMeta } from "/opt/build/repo/pages/sessions/[id]/associate/[user_id]/waiting-room.vue?macro=true";
import { default as sessionsLL7q9KZbJ9SazBom6lhvBiVF8jfg2J_45Ss3gAvvp8OnUMeta } from "/opt/build/repo/pages/sessions.vue?macro=true";
import { default as _91_46_46_46slug_93bxqMJRabVdWZXuvF9FWZmMIujcSvRxUBxs5JzQp4EB0Meta } from "/opt/build/repo/pages/[...slug].vue?macro=true";
import { default as edit8nsw_g1nAQK12HbturutMcyPqys37vvp6Teuul8frsQMeta } from "/opt/build/repo/pages/user/edit.vue?macro=true";
import { default as typeyS0tbSrpnfvBDtljh1iYvuZsyRuGf3RX4vcnAl3VK8YMeta } from "/opt/build/repo/pages/onboarding/type.vue?macro=true";
import { default as indexFPlknJoBjJrRlhEnTGPTAKlG2cBCn3cDruEcJQJrmM4Meta } from "/opt/build/repo/pages/onboarding/index.vue?macro=true";
import { default as verifymVAWEUHQno2AHBF6FrxN6surecIf2i49Hfw3vfmqLAsMeta } from "/opt/build/repo/pages/onboarding/verify.vue?macro=true";
import { default as accountcmVknAzM2w7KtHxwfS_6JM_CKdT8Oyh1_45FlgyroQ7BQMeta } from "/opt/build/repo/pages/onboarding/account.vue?macro=true";
import { default as invoice_NBM84aroWY1CtH1q7UYQIwM6HoXUdzJdAUDJFxJV28Meta } from "/opt/build/repo/pages/onboarding/invoice.vue?macro=true";
import { default as paymentGIsuTEdY_45_Eg2G9z5bbYyI_45ukdshzawvenl6SiW_FhcMeta } from "/opt/build/repo/pages/onboarding/payment.vue?macro=true";
import { default as contacts7pVUhpIfxPPIaVpAtBnRj7Hf5Im28pFxmnHgZ4tYPIwMeta } from "/opt/build/repo/pages/onboarding/contacts.vue?macro=true";
import { default as agreement9WsS8nJO_6cKqyk1Jk_zoZM5WqJAKOFQYyTMY3bB5E4Meta } from "/opt/build/repo/pages/onboarding/agreement.vue?macro=true";
import { default as customizesd76gX8UtFHubHKmOlFSiDP5lj3yglMvWSLiXPt3H3oMeta } from "/opt/build/repo/pages/onboarding/customize.vue?macro=true";
import { default as join_45account4OMX3z0kQrD3SNo8xaDEk_8gxQY_HKRdtxh3Zext5UsMeta } from "/opt/build/repo/pages/onboarding/join-account.vue?macro=true";
import { default as onboardingUtpcyzpRHTInco0za2ihqdRvfsTCNl66s5xksqWJI9MMeta } from "/opt/build/repo/pages/onboarding.vue?macro=true";
import { default as closedvbMPPSzu_UgTo1BPk1QoPapuziCq9QGOdvW6hM8SBBsMeta } from "/opt/build/repo/pages/system/closed.vue?macro=true";
import { default as password_45resetrA5U_45qvrQgOBWUDIa8d_n9u5BYethtWKGMvU9TrGVewMeta } from "/opt/build/repo/pages/password-reset.vue?macro=true";
import { default as privacy_45policyPl1ixjl54PV0rmR_45TVWtLEI_4n7GqlEsEe__45AeHGvHsMeta } from "/opt/build/repo/pages/privacy-policy.vue?macro=true";
import { default as pendingnWPOpNV9mq52fpNUaPwh8BH_45BnWW3qo84kw1bkdWgToMeta } from "/opt/build/repo/pages/system/pending.vue?macro=true";
import { default as indexuQq0imnnfrPw8uKN43HltnSUjTR_455mbF9z3r1h9KDcgMeta } from "/opt/build/repo/pages/join/[id]/index.vue?macro=true";
import { default as indexGkxYe2RbnoFyg8fl2PL0GEhwXKI2al04sC_J315nOmMMeta } from "/opt/build/repo/pages/operations/index.vue?macro=true";
import { default as not_45foundKFrqKdYm3gBCWVDAWho2KF5hH6t1Ie8aB2vRjEG2_SgMeta } from "/opt/build/repo/pages/system/not-found.vue?macro=true";
import { default as suspended9vn7YOlpJ2727A5cw0ba9xsLsHJqebn2SlIj9PfFoq8Meta } from "/opt/build/repo/pages/system/suspended.vue?macro=true";
import { default as terms_45of_45service98Sl0B0s_45g1s2xKjJxHo5NIQaSuNWr6QRk_45t4WriR78Meta } from "/opt/build/repo/pages/terms-of-service.vue?macro=true";
import { default as maintenancegwDf0ZoJ7nGu_45hZ1ONOrBBjOHBV8Y7TLzfsvNUWX8NYMeta } from "/opt/build/repo/pages/system/maintenance.vue?macro=true";
export default [
  {
    name: hubmNiv2cv4u1_oKaBSzPzbCPBH9RJ9KB2VhDNzafiPAfIMeta?.name,
    path: "/hub",
    meta: hubmNiv2cv4u1_oKaBSzPzbCPBH9RJ9KB2VhDNzafiPAfIMeta || {},
    component: () => import("/opt/build/repo/pages/hub.vue"),
    children: [
  {
    name: "hub",
    path: "",
    component: () => import("/opt/build/repo/pages/hub/index.vue")
  },
  {
    name: "hub-suspended",
    path: "suspended",
    meta: suspendedsEU2qvBQddSkwdtJf7ahl_45IxSmzjOW6VW7Dw8oT2Ni0Meta || {},
    component: () => import("/opt/build/repo/pages/hub/suspended.vue")
  },
  {
    name: "hub-account",
    path: "account",
    meta: { ...(indexvKPPGPyr_guk0IVYXGxgb1nU8ZiH_OI_45VVyI8xvxIvwMeta || {}), ...{"middleware":["non-app","account"]} },
    component: () => import("/opt/build/repo/pages/hub/account/index.vue")
  },
  {
    name: "hub-clients",
    path: "clients",
    meta: { ...(index9ICLOfg7B7amsMhTcN4j_OvHCli5DTLCYi_ltn1tIkYMeta || {}), ...{"middleware":"non-app"} },
    component: () => import("/opt/build/repo/pages/hub/clients/index.vue")
  },
  {
    name: "hub-sessions",
    path: "sessions",
    meta: { ...(indexI_45_P6dm0_456qcvZVG_45bPneLY_6HAIailMPWKraGPWCMQMeta || {}), ...{"middleware":"non-app"} },
    component: () => import("/opt/build/repo/pages/hub/sessions/index.vue")
  },
  {
    name: "hub-sessions-create",
    path: "sessions/create",
    meta: { ...(indexoEgaBwvvnutiRni0n9DxaO2A56AexhITapcprCku4LQMeta || {}), ...{"middleware":["non-app","suspended"]} },
    component: () => import("/opt/build/repo/pages/hub/sessions/create/index.vue")
  },
  {
    name: "hub-clients-client_id-edit",
    path: "clients/:client_id()/edit",
    component: () => import("/opt/build/repo/pages/hub/clients/[client_id]/edit.vue")
  },
  {
    name: "hub-sessions-session_id-edit",
    path: "sessions/:session_id()/edit",
    meta: { ...(editV_Yd9cIh4wQrIXe0x0XAZx_EpGtqP4bFfPz13jwhV_45UMeta || {}), ...{"middleware":["non-app","suspended"]} },
    component: () => import("/opt/build/repo/pages/hub/sessions/[session_id]/edit.vue")
  },
  {
    name: "hub-account-invoices-invoice_id",
    path: "account/invoices/:invoice_id()",
    meta: {"middleware":["non-app","account"]},
    component: () => import("/opt/build/repo/pages/hub/account/invoices/[invoice_id].vue")
  },
  {
    name: "hub-sessions-create-session_id-documents",
    path: "sessions/create/:session_id()/documents",
    meta: { ...(documentsIZepVEPJ16bnbEsSitC4pVuq81ONY1kG9HfCy6gi2EEMeta || {}), ...{"middleware":"non-app"} },
    component: () => import("/opt/build/repo/pages/hub/sessions/create/[session_id]/documents.vue")
  },
  {
    name: "hub-sessions-create-session_id-participants",
    path: "sessions/create/:session_id()/participants",
    meta: { ...(participantsY2gE5VLn8XqvI5AphdFKKgcw14403radM1qSQcK7bTYMeta || {}), ...{"middleware":"non-app"} },
    component: () => import("/opt/build/repo/pages/hub/sessions/create/[session_id]/participants.vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: logindGU_Y4tTcWsCg9HnKfbgxniTJNnqn8Xqf4N3mbSf_459QMeta?.name,
    path: "/login",
    meta: { ...(logindGU_Y4tTcWsCg9HnKfbgxniTJNnqn8Xqf4N3mbSf_459QMeta || {}), ...{"middleware":["loggin"]} },
    component: () => import("/opt/build/repo/pages/login.vue"),
    children: [
  {
    name: "login",
    path: "",
    meta: index6KQYwgCt1bTcRoYAAw64KdwsuCkHaNYI9qRHwfpdOpQMeta || {},
    component: () => import("/opt/build/repo/pages/login/index.vue")
  },
  {
    name: "login-oauth",
    path: "oauth",
    meta: { ...(oauthSX9eDY39UBORomKrrZzipex62cw5B6akB1H1HP4iFt4Meta || {}), ...{"middleware":["oauth"]} },
    component: () => import("/opt/build/repo/pages/login/oauth.vue")
  },
  {
    name: "login-select-oauth",
    path: "select-oauth",
    meta: { ...(select_45oauthVWo21jhGfESXhPONAabowj4dMEqh4lWi34zDLAlbmZsMeta || {}), ...{"middleware":["oauth"]} },
    component: () => import("/opt/build/repo/pages/login/select-oauth.vue")
  },
  {
    name: "login-password-reset",
    path: "password-reset",
    meta: password_45resetqOut8h6ALHg0APwIUPE_w7Oyccu0Fb6WYL4NkjDWbB4Meta || {},
    component: () => import("/opt/build/repo/pages/login/password-reset.vue")
  }
]
  },
  {
    name: inviteWTVDyqcmIHtlgmEznuu6azMupVUNcfFh5sgHx2EV1IEMeta?.name,
    path: "/invite",
    component: () => import("/opt/build/repo/pages/invite.vue"),
    children: [
  {
    name: "invite",
    path: "",
    meta: { ...(indextXLW_dFSGz_9a3jkVO90qLt_uAi4pnbXFWbQLtlLJ_45MMeta || {}), ...{"middleware":["invite"]} },
    component: () => import("/opt/build/repo/pages/invite/index.vue")
  },
  {
    name: "invite-oauth",
    path: "oauth",
    meta: { ...(oauthDCMwZQAzdz07_458boGPq332Rb6juKbqZLL2WUlUlDX1wMeta || {}), ...{"middleware":["oauth-invite"]} },
    component: () => import("/opt/build/repo/pages/invite/oauth.vue")
  },
  {
    name: "invite-select-oauth",
    path: "select-oauth",
    meta: { ...(select_45oauth_45Xv_45LPQ7xmh4A6Tx_xRWPGZPxiFA2iOPLw4xa5dhOMUMeta || {}), ...{"middleware":["oauth-invite"]} },
    component: () => import("/opt/build/repo/pages/invite/select-oauth.vue")
  }
]
  },
  {
    name: "switch",
    path: "/switch",
    meta: { ...(switch_45n0bdRXGEX5fzYjsHszhhVmTx7gzGHJQpz1wJ_45uEVHQMeta || {}), ...{"middleware":["switch"]} },
    component: () => import("/opt/build/repo/pages/switch.vue")
  },
  {
    name: "records",
    path: "/records",
    meta: recordsx0LcFab84A3DhY1vsDcEOIN0U3_45wIg6nEb5NYfNoTTUMeta || {},
    component: () => import("/opt/build/repo/pages/records.vue"),
    children: [
  {
    name: "records-texas",
    path: "texas",
    meta: indexSl0IssOD6uDAvLb3_45PAwS0iJP9J0QLhAFbtCgOMGgn8Meta || {},
    component: () => import("/opt/build/repo/pages/records/texas/index.vue")
  },
  {
    name: "records-texas-create",
    path: "texas/create",
    meta: create95T2MaEwas7Ob75YRs8k0pelWiN3ges5VyNb8YA21_MMeta || {},
    component: () => import("/opt/build/repo/pages/records/texas/create.vue")
  },
  {
    name: "records-alabama",
    path: "alabama",
    meta: index9E9n5O9FqIzgsX9WS575OCMURXALA_UuX_45Lq37t33rgMeta || {},
    component: () => import("/opt/build/repo/pages/records/alabama/index.vue")
  },
  {
    name: "records-florida",
    path: "florida",
    meta: indexHZfv9EzqOpitMeUkDeFbbVPWc3cX0ldiw7ab5bbLzGgMeta || {},
    component: () => import("/opt/build/repo/pages/records/florida/index.vue")
  },
  {
    name: "records-georgia",
    path: "georgia",
    meta: index2o_Oy_45fcp15C_458uHVJjxqfj7DNgAIbGV14hTD389wDwMeta || {},
    component: () => import("/opt/build/repo/pages/records/georgia/index.vue")
  },
  {
    name: "records-alabama-create",
    path: "alabama/create",
    meta: create6jgrO8IiduLsUt7fJyiodD2GnzsTOhGwVOdf8qCONG8Meta || {},
    component: () => import("/opt/build/repo/pages/records/alabama/create.vue")
  },
  {
    name: "records-florida-create",
    path: "florida/create",
    meta: createzPSRpU15yNNvKkLIL5KGH4PIdYp5895Iw8qlzNmi5MQMeta || {},
    component: () => import("/opt/build/repo/pages/records/florida/create.vue")
  },
  {
    name: "records-georgia-create",
    path: "georgia/create",
    meta: createqlnuVhBIQrs56hSiSqPVniXDIv3IMP1dZu0wlFYLAyUMeta || {},
    component: () => import("/opt/build/repo/pages/records/georgia/create.vue")
  },
  {
    name: "records-illinois",
    path: "illinois",
    meta: indexr4WgwGPVkoLEvejHlpRDTx71RfkQdiZo_45oEfBJMbPdEMeta || {},
    component: () => import("/opt/build/repo/pages/records/illinois/index.vue")
  },
  {
    name: "records-new-york",
    path: "new-york",
    meta: indexySIo6uGiHw0c_45U3P0hyTIEJ8ZFtUqV3a9fKHcpAWpMAMeta || {},
    component: () => import("/opt/build/repo/pages/records/new-york/index.vue")
  },
  {
    name: "records-virginia",
    path: "virginia",
    meta: indexoy8hMpFkQbVxezkwtiD8ESGqqZ3gcRhwTtuUvOe2wRwMeta || {},
    component: () => import("/opt/build/repo/pages/records/virginia/index.vue")
  },
  {
    name: "records-illinois-create",
    path: "illinois/create",
    meta: createRD9VD3q_45wmlz0pwJyhSb5ZBJSdsAuXSBvOcMmNtChJEMeta || {},
    component: () => import("/opt/build/repo/pages/records/illinois/create.vue")
  },
  {
    name: "records-new-york-create",
    path: "new-york/create",
    meta: creategKZmyaJadtp0r8bS_45pFg6p3BYwPiG3Joij9947Tlu8wMeta || {},
    component: () => import("/opt/build/repo/pages/records/new-york/create.vue")
  },
  {
    name: "records-tennessee",
    path: "tennessee",
    meta: indexwraGnHrpZ47VywK8_TigvLxxXqZ8XSjUzSAxNu3po_45kMeta || {},
    component: () => import("/opt/build/repo/pages/records/tennessee/index.vue")
  },
  {
    name: "records-virginia-create",
    path: "virginia/create",
    meta: createwGBdot9ka2wMzMBV_45VF63pYVQ_RgIjO1KW7s8U55oZ0Meta || {},
    component: () => import("/opt/build/repo/pages/records/virginia/create.vue")
  },
  {
    name: "records-new-jersey",
    path: "new-jersey",
    meta: indexwa70T5on_UVMa1IUOdxRQ7aSg2RU9A4TRn_45NuNz_jy4Meta || {},
    component: () => import("/opt/build/repo/pages/records/new-jersey/index.vue")
  },
  {
    name: "records-tennessee-create",
    path: "tennessee/create",
    meta: createISySZOmBoQkf6C_VjgP1CuuY4KWAFvcH4DQfaKzLwBgMeta || {},
    component: () => import("/opt/build/repo/pages/records/tennessee/create.vue")
  },
  {
    name: "records-mississippi",
    path: "mississippi",
    meta: index_45253olsAPpqKAziYhNXpb5peh34kGUnvXCWlEooftqkMeta || {},
    component: () => import("/opt/build/repo/pages/records/mississippi/index.vue")
  },
  {
    name: "records-new-jersey-create",
    path: "new-jersey/create",
    meta: createJPAyqh8NMjUlkWEKzHt9t47NFs_ESRPur61la5TS4LYMeta || {},
    component: () => import("/opt/build/repo/pages/records/new-jersey/create.vue")
  },
  {
    name: "records-mississippi-create",
    path: "mississippi/create",
    meta: createjK65T_cBNcLSt_45Xtsm1hb_eZ2oI_DY4qK48sSaRR5r8Meta || {},
    component: () => import("/opt/build/repo/pages/records/mississippi/create.vue")
  },
  {
    name: "records-texas-record_id-edit",
    path: "texas/:record_id()/edit",
    meta: editoAQZ1HjyqNinSCLimi0oQuEQdmj5q0GnEm_45D2Aa8tvAMeta || {},
    component: () => import("/opt/build/repo/pages/records/texas/[record_id]/edit.vue")
  },
  {
    name: "records-alabama-record_id-edit",
    path: "alabama/:record_id()/edit",
    meta: editItKNiPCl7Dxzi2diKSG8nlow3ue_45EA8jzvFgiQGUoosMeta || {},
    component: () => import("/opt/build/repo/pages/records/alabama/[record_id]/edit.vue")
  },
  {
    name: "records-florida-record_id-edit",
    path: "florida/:record_id()/edit",
    meta: editaFMJwUMDJXQ4zaLM7xWwnwRa3fbstqKecBeNVBPByycMeta || {},
    component: () => import("/opt/build/repo/pages/records/florida/[record_id]/edit.vue")
  },
  {
    name: "records-georgia-record_id-edit",
    path: "georgia/:record_id()/edit",
    meta: editgK7gsL1jV378x_mPzdo4ThKu510ISE3nDj9xPi3byOAMeta || {},
    component: () => import("/opt/build/repo/pages/records/georgia/[record_id]/edit.vue")
  },
  {
    name: "records-illinois-record_id-edit",
    path: "illinois/:record_id()/edit",
    meta: editZW5Jp66Lj8e2mbtKZP4_450Ch3daFJKKaR9F21CbXilg4Meta || {},
    component: () => import("/opt/build/repo/pages/records/illinois/[record_id]/edit.vue")
  },
  {
    name: "records-new-york-record_id-edit",
    path: "new-york/:record_id()/edit",
    meta: editsf8b_45Iaicl0Hw8ZkYx_45PCXBjVifuuaxSU32pVuV5ZgMMeta || {},
    component: () => import("/opt/build/repo/pages/records/new-york/[record_id]/edit.vue")
  },
  {
    name: "records-virginia-record_id-edit",
    path: "virginia/:record_id()/edit",
    meta: edit_bpHLOY6jMwakvJ67oYkq_lWOvzm1M6ZbR0iL39IHF4Meta || {},
    component: () => import("/opt/build/repo/pages/records/virginia/[record_id]/edit.vue")
  },
  {
    name: "records-tennessee-record_id-edit",
    path: "tennessee/:record_id()/edit",
    meta: edit_459E3sCtN6gXZruRJciNmbxMYmFYgwt6niXB9DNk4awQMeta || {},
    component: () => import("/opt/build/repo/pages/records/tennessee/[record_id]/edit.vue")
  },
  {
    name: "records-new-jersey-record_id-edit",
    path: "new-jersey/:record_id()/edit",
    meta: editcrGV8jxOzrWLKedQ_45eHHtHA3dnC_3bsUmZMrGVpo4zEMeta || {},
    component: () => import("/opt/build/repo/pages/records/new-jersey/[record_id]/edit.vue")
  },
  {
    name: "records-mississippi-record_id-edit",
    path: "mississippi/:record_id()/edit",
    meta: edithzZpBtZmtkgWEsWbfiCtDSX9m1IpM47_45L816J3dh1Z8Meta || {},
    component: () => import("/opt/build/repo/pages/records/mississippi/[record_id]/edit.vue")
  }
]
  },
  {
    name: registereUFPUgCXbUbkM74KdKqZIrJcc_QOIXBANMYTn5YpRlAMeta?.name,
    path: "/register",
    meta: { ...(registereUFPUgCXbUbkM74KdKqZIrJcc_QOIXBANMYTn5YpRlAMeta || {}), ...{"middleware":"loggin"} },
    component: () => import("/opt/build/repo/pages/register.vue"),
    children: [
  {
    name: "register",
    path: "",
    meta: indexAv7N_GC9_wZAErchdYW2102WxkHu36pGyLXcYB_vSl8Meta || {},
    component: () => import("/opt/build/repo/pages/register/index.vue")
  },
  {
    name: "register-details",
    path: "details",
    meta: detailsB8WUJK1XpcRjoSn_BEYsgxChFjuwC5k97okamRyl3jgMeta || {},
    component: () => import("/opt/build/repo/pages/register/details.vue")
  },
  {
    name: "register-password",
    path: "password",
    meta: password_45_hTiOuEgHswyAV4SXXfmO4h7MegUpcdpk8VoFC0v7IMeta || {},
    component: () => import("/opt/build/repo/pages/register/password.vue")
  },
  {
    name: "register-verification",
    path: "verification",
    meta: verificationJ_45agRQ8Cq8OJJlmOxRwp1H6yuVT8Mpq_UMBZOMHmlT0Meta || {},
    component: () => import("/opt/build/repo/pages/register/verification.vue")
  },
  {
    name: "register-acknowledgment",
    path: "acknowledgment",
    meta: acknowledgment_vmXc_woHYfEQOWL0lZpxMV7L03pSCi8PBOfBX0xsP0Meta || {},
    component: () => import("/opt/build/repo/pages/register/acknowledgment.vue")
  }
]
  },
  {
    name: sessionsLL7q9KZbJ9SazBom6lhvBiVF8jfg2J_45Ss3gAvvp8OnUMeta?.name,
    path: "/sessions",
    component: () => import("/opt/build/repo/pages/sessions.vue"),
    children: [
  {
    name: "sessions",
    path: "",
    meta: index6RX3n4Mh8_45tuXj_7f6_45m1k4cTd0JZ7DHf09neFWItBsMeta || {},
    component: () => import("/opt/build/repo/pages/sessions/index.vue")
  },
  {
    name: "sessions-id-documents-edit",
    path: ":id()/documents/edit",
    meta: edit7A_45fGA5qyLcQrZAmk9YC36AewMFRuhgVVlXyZ_1SLN8Meta || {},
    component: () => import("/opt/build/repo/pages/sessions/[id]/documents/edit.vue")
  },
  {
    name: "sessions-id-host-user_id-room",
    path: ":id()/host/:user_id()/room",
    meta: { ...(roomhttqjr1INYSieHwC6W9J0fKjGR54_45sMge1j0le_45muRQMeta || {}), ...{"middleware":"host"} },
    component: () => import("/opt/build/repo/pages/sessions/[id]/host/[user_id]/room.vue")
  },
  {
    name: "sessions-id-team-user_id-room",
    path: ":id()/team/:user_id()/room",
    meta: { ...(roomv5RKVgCdE_45ejKcD_jwKAw8aekJdIRfLHZx956FcwI7MMeta || {}), ...{"middleware":"participent"} },
    component: () => import("/opt/build/repo/pages/sessions/[id]/team/[user_id]/room.vue")
  },
  {
    name: "sessions-id-client-user_id-kba",
    path: ":id()/client/:user_id()/kba",
    meta: { ...(kbagzQcUza1D90Oh2P36O5oNCbsivtEZpTWP3LSFVFr9e0Meta || {}), ...{"middleware":["participent","suspended"]} },
    component: () => import("/opt/build/repo/pages/sessions/[id]/client/[user_id]/kba.vue")
  },
  {
    name: "sessions-id-host-user_id",
    path: ":id()/host/:user_id()",
    meta: { ...(indexuXMimp7AT5M_45f9YQ5urTDtoe5S4_TN4cfRfpS3d88ZUMeta || {}), ...{"middleware":["host","suspended"]} },
    component: () => import("/opt/build/repo/pages/sessions/[id]/host/[user_id]/index.vue")
  },
  {
    name: "sessions-id-team-user_id",
    path: ":id()/team/:user_id()",
    meta: { ...(indexnKNhax1Rn_45sQHZY9KOwbSmxz88o2SSyr6s859NaCHrAMeta || {}), ...{"middleware":"participent-login"} },
    component: () => import("/opt/build/repo/pages/sessions/[id]/team/[user_id]/index.vue")
  },
  {
    name: "sessions-id-client-user_id-auth",
    path: ":id()/client/:user_id()/auth",
    meta: { ...(auths63Np8Gd_458YZIM_UKW7tVv6Iz1HDtusy9QFlv3HhfP4Meta || {}), ...{"middleware":["participent","suspended"]} },
    component: () => import("/opt/build/repo/pages/sessions/[id]/client/[user_id]/auth.vue")
  },
  {
    name: "sessions-id-client-user_id-room",
    path: ":id()/client/:user_id()/room",
    meta: { ...(roomT7cNFBfaMIUG5xVqO4J3pu_45i7BqOnlY5PcP2fFcTl0kMeta || {}), ...{"middleware":["participent","suspended"]} },
    component: () => import("/opt/build/repo/pages/sessions/[id]/client/[user_id]/room.vue")
  },
  {
    name: "sessions-id-witness-user_id-kba",
    path: ":id()/witness/:user_id()/kba",
    meta: { ...(kbaeH9jacoI0GfsVk4bNRziw5KBblINwoCyjgTgwqZW4ToMeta || {}), ...{"middleware":["participent","suspended"]} },
    component: () => import("/opt/build/repo/pages/sessions/[id]/witness/[user_id]/kba.vue")
  },
  {
    name: "sessions-id-client-user_id",
    path: ":id()/client/:user_id()",
    meta: { ...(index6gJawRqYwfEN09GDl3iP_0JhPmQT_5gYmP5kuSgylOwMeta || {}), ...{"middleware":["client-login","suspended"]} },
    component: () => import("/opt/build/repo/pages/sessions/[id]/client/[user_id]/index.vue")
  },
  {
    name: "sessions-id-witness-user_id-auth",
    path: ":id()/witness/:user_id()/auth",
    meta: { ...(authdiyHRGOVfnfeCCYMln3_KvATJ4gJ_5_45TIWq4cJQuX9QMeta || {}), ...{"middleware":["participent","suspended"]} },
    component: () => import("/opt/build/repo/pages/sessions/[id]/witness/[user_id]/auth.vue")
  },
  {
    name: "sessions-id-witness-user_id-room",
    path: ":id()/witness/:user_id()/room",
    meta: { ...(roomuRNvYFLVw5LIV8s_45DRIdkZbe_45ngqgOprzcDOMqenmsEMeta || {}), ...{"middleware":["participent","suspended"]} },
    component: () => import("/opt/build/repo/pages/sessions/[id]/witness/[user_id]/room.vue")
  },
  {
    name: "sessions-id-client-user_id-denied",
    path: ":id()/client/:user_id()/denied",
    meta: { ...(denied2LGeVXEEmP02WHf0NLJ_45r_OWewVEuJzyAlLheRLtRh0Meta || {}), ...{"middleware":"denied"} },
    component: () => import("/opt/build/repo/pages/sessions/[id]/client/[user_id]/denied.vue")
  },
  {
    name: "sessions-id-client-user_id-switch",
    path: ":id()/client/:user_id()/switch",
    meta: { ...(switchq2KVdjTKVr3dIHuK4ld2ig_G_IJsyrCUuwmLWf7o_45jAMeta || {}), ...{"middleware":"participent"} },
    component: () => import("/opt/build/repo/pages/sessions/[id]/client/[user_id]/switch.vue")
  },
  {
    name: "sessions-id-witness-user_id",
    path: ":id()/witness/:user_id()",
    meta: { ...(index011fQnmsho7PF74VrZW1CFmlsfYRXQdunP3HNmRQG74Meta || {}), ...{"middleware":["participent-login","suspended"]} },
    component: () => import("/opt/build/repo/pages/sessions/[id]/witness/[user_id]/index.vue")
  },
  {
    name: "sessions-id-associate-user_id-room",
    path: ":id()/associate/:user_id()/room",
    meta: { ...(roomRO7RvqCyobuvJT4SlXIZuj_PXZ2fsPdKFNv1R22Ti8MMeta || {}), ...{"middleware":"participent"} },
    component: () => import("/opt/build/repo/pages/sessions/[id]/associate/[user_id]/room.vue")
  },
  {
    name: "sessions-id-client-user_id-details",
    path: ":id()/client/:user_id()/details",
    meta: { ...(detailspSqytjV93raQ5IDbMQ4spgB_45cD_45Tdwnht5mkDgd2vdsMeta || {}), ...{"middleware":["participent","suspended"]} },
    component: () => import("/opt/build/repo/pages/sessions/[id]/client/[user_id]/details.vue")
  },
  {
    name: "sessions-id-client-user_id-preview",
    path: ":id()/client/:user_id()/preview",
    meta: { ...(previewjFAbGSlM9HWf76cfOZhOGActzuPTz2P6qa6vWcrxcJUMeta || {}), ...{"middleware":["participent","suspended"]} },
    component: () => import("/opt/build/repo/pages/sessions/[id]/client/[user_id]/preview.vue")
  },
  {
    name: "sessions-id-witness-user_id-denied",
    path: ":id()/witness/:user_id()/denied",
    meta: { ...(deniedSsj1W_GoxNnjV01s_45EYHwLKvoaT4zUfWyz16WYG9ZCMMeta || {}), ...{"middleware":"denied"} },
    component: () => import("/opt/build/repo/pages/sessions/[id]/witness/[user_id]/denied.vue")
  },
  {
    name: "sessions-id-associate-user_id",
    path: ":id()/associate/:user_id()",
    meta: { ...(indexLXQl5uheEhVVWovXEur3OeSkBw6tT2oTRJ2Z8KA5BqYMeta || {}), ...{"middleware":"participent-login"} },
    component: () => import("/opt/build/repo/pages/sessions/[id]/associate/[user_id]/index.vue")
  },
  {
    name: "sessions-id-client-user_id-download",
    path: ":id()/client/:user_id()/download",
    meta: { ...(downloadHWJYHqLU2nl_454_4584SYAy0EAbZvj6iCjutgxwlH0KXzEMeta || {}), ...{"middleware":"participent"} },
    component: () => import("/opt/build/repo/pages/sessions/[id]/client/[user_id]/download.vue")
  },
  {
    name: "sessions-id-witness-user_id-details",
    path: ":id()/witness/:user_id()/details",
    meta: { ...(detailsdLomsDGdtZJ5ib_BEE1_45TWnHRSbvNLQgy5B9veBwO4UMeta || {}), ...{"middleware":["participent","suspended"]} },
    component: () => import("/opt/build/repo/pages/sessions/[id]/witness/[user_id]/details.vue")
  },
  {
    name: "sessions-id-client-user_id-questions",
    path: ":id()/client/:user_id()/questions",
    meta: { ...(questionsu6wyXpRQEgNBYZVCq7Bfu1Af6_1SLkQrtgWbxLaGrQoMeta || {}), ...{"middleware":["participent","suspended"]} },
    component: () => import("/opt/build/repo/pages/sessions/[id]/client/[user_id]/questions.vue")
  },
  {
    name: "sessions-id-associate-user_id-details",
    path: ":id()/associate/:user_id()/details",
    meta: { ...(detailsrwFRO2_455OTkrns6fDhUZVWEBJCWqpBVLDl1hh8wTe1UMeta || {}), ...{"middleware":"participent"} },
    component: () => import("/opt/build/repo/pages/sessions/[id]/associate/[user_id]/details.vue")
  },
  {
    name: "sessions-id-team-user_id-waiting-room",
    path: ":id()/team/:user_id()/waiting-room",
    meta: { ...(waiting_45roomvfPX5cUAMpyWpAARToJ7A0odev8aGtvuOj9x1D6tbvoMeta || {}), ...{"middleware":"participent"} },
    component: () => import("/opt/build/repo/pages/sessions/[id]/team/[user_id]/waiting-room.vue")
  },
  {
    name: "sessions-id-client-user_id-waiting-room",
    path: ":id()/client/:user_id()/waiting-room",
    meta: { ...(waiting_45roomgfjdJs0zrGXmfjVPS7Ex_45iwRqfcvQh_4KxF2n25T4UoMeta || {}), ...{"middleware":["participent","suspended"]} },
    component: () => import("/opt/build/repo/pages/sessions/[id]/client/[user_id]/waiting-room.vue")
  },
  {
    name: "sessions-id-witness-user_id-waiting-room",
    path: ":id()/witness/:user_id()/waiting-room",
    meta: { ...(waiting_45room6D4vwQUYF86PqHH8XyPo3UE8SN7PqqiKW6fvesj_45Y_UMeta || {}), ...{"middleware":["participent","suspended"]} },
    component: () => import("/opt/build/repo/pages/sessions/[id]/witness/[user_id]/waiting-room.vue")
  },
  {
    name: "sessions-id-associate-user_id-waiting-room",
    path: ":id()/associate/:user_id()/waiting-room",
    meta: { ...(waiting_45roompKoUrdh7A9YmSC7qTQ_nCUhgozYyvFNwMewM4NptVZcMeta || {}), ...{"middleware":"participent"} },
    component: () => import("/opt/build/repo/pages/sessions/[id]/associate/[user_id]/waiting-room.vue")
  }
]
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/opt/build/repo/pages/[...slug].vue")
  },
  {
    name: "user-edit",
    path: "/user/edit",
    meta: edit8nsw_g1nAQK12HbturutMcyPqys37vvp6Teuul8frsQMeta || {},
    component: () => import("/opt/build/repo/pages/user/edit.vue")
  },
  {
    name: onboardingUtpcyzpRHTInco0za2ihqdRvfsTCNl66s5xksqWJI9MMeta?.name,
    path: "/onboarding",
    meta: onboardingUtpcyzpRHTInco0za2ihqdRvfsTCNl66s5xksqWJI9MMeta || {},
    component: () => import("/opt/build/repo/pages/onboarding.vue"),
    children: [
  {
    name: "onboarding-type",
    path: "type",
    meta: { ...(typeyS0tbSrpnfvBDtljh1iYvuZsyRuGf3RX4vcnAl3VK8YMeta || {}), ...{"middleware":["onboarding"]} },
    component: () => import("/opt/build/repo/pages/onboarding/type.vue")
  },
  {
    name: "onboarding",
    path: "",
    meta: { ...(indexFPlknJoBjJrRlhEnTGPTAKlG2cBCn3cDruEcJQJrmM4Meta || {}), ...{"middleware":["onboarding"]} },
    component: () => import("/opt/build/repo/pages/onboarding/index.vue")
  },
  {
    name: "onboarding-verify",
    path: "verify",
    meta: { ...(verifymVAWEUHQno2AHBF6FrxN6surecIf2i49Hfw3vfmqLAsMeta || {}), ...{"middleware":["onboarding"]} },
    component: () => import("/opt/build/repo/pages/onboarding/verify.vue")
  },
  {
    name: "onboarding-account",
    path: "account",
    meta: { ...(accountcmVknAzM2w7KtHxwfS_6JM_CKdT8Oyh1_45FlgyroQ7BQMeta || {}), ...{"middleware":["onboarding"]} },
    component: () => import("/opt/build/repo/pages/onboarding/account.vue")
  },
  {
    name: "onboarding-invoice",
    path: "invoice",
    meta: { ...(invoice_NBM84aroWY1CtH1q7UYQIwM6HoXUdzJdAUDJFxJV28Meta || {}), ...{"middleware":["onboarding"]} },
    component: () => import("/opt/build/repo/pages/onboarding/invoice.vue")
  },
  {
    name: "onboarding-payment",
    path: "payment",
    meta: { ...(paymentGIsuTEdY_45_Eg2G9z5bbYyI_45ukdshzawvenl6SiW_FhcMeta || {}), ...{"middleware":["final-onboarding"]} },
    component: () => import("/opt/build/repo/pages/onboarding/payment.vue")
  },
  {
    name: "onboarding-contacts",
    path: "contacts",
    meta: { ...(contacts7pVUhpIfxPPIaVpAtBnRj7Hf5Im28pFxmnHgZ4tYPIwMeta || {}), ...{"middleware":["final-onboarding"]} },
    component: () => import("/opt/build/repo/pages/onboarding/contacts.vue")
  },
  {
    name: "onboarding-agreement",
    path: "agreement",
    meta: { ...(agreement9WsS8nJO_6cKqyk1Jk_zoZM5WqJAKOFQYyTMY3bB5E4Meta || {}), ...{"middleware":["final-onboarding"]} },
    component: () => import("/opt/build/repo/pages/onboarding/agreement.vue")
  },
  {
    name: "onboarding-customize",
    path: "customize",
    meta: { ...(customizesd76gX8UtFHubHKmOlFSiDP5lj3yglMvWSLiXPt3H3oMeta || {}), ...{"middleware":["onboarding"]} },
    component: () => import("/opt/build/repo/pages/onboarding/customize.vue")
  },
  {
    name: "onboarding-join-account",
    path: "join-account",
    meta: { ...(join_45account4OMX3z0kQrD3SNo8xaDEk_8gxQY_HKRdtxh3Zext5UsMeta || {}), ...{"middleware":["onboarding"]} },
    component: () => import("/opt/build/repo/pages/onboarding/join-account.vue")
  }
]
  },
  {
    name: "system-closed",
    path: "/system/closed",
    meta: closedvbMPPSzu_UgTo1BPk1QoPapuziCq9QGOdvW6hM8SBBsMeta || {},
    component: () => import("/opt/build/repo/pages/system/closed.vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: { ...(password_45resetrA5U_45qvrQgOBWUDIa8d_n9u5BYethtWKGMvU9TrGVewMeta || {}), ...{"middleware":"password-reset"} },
    component: () => import("/opt/build/repo/pages/password-reset.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: privacy_45policyPl1ixjl54PV0rmR_45TVWtLEI_4n7GqlEsEe__45AeHGvHsMeta || {},
    component: () => import("/opt/build/repo/pages/privacy-policy.vue")
  },
  {
    name: "system-pending",
    path: "/system/pending",
    meta: pendingnWPOpNV9mq52fpNUaPwh8BH_45BnWW3qo84kw1bkdWgToMeta || {},
    component: () => import("/opt/build/repo/pages/system/pending.vue")
  },
  {
    name: "join-id",
    path: "/join/:id()",
    meta: indexuQq0imnnfrPw8uKN43HltnSUjTR_455mbF9z3r1h9KDcgMeta || {},
    component: () => import("/opt/build/repo/pages/join/[id]/index.vue")
  },
  {
    name: "operations",
    path: "/operations",
    component: () => import("/opt/build/repo/pages/operations/index.vue")
  },
  {
    name: "system-not-found",
    path: "/system/not-found",
    meta: not_45foundKFrqKdYm3gBCWVDAWho2KF5hH6t1Ie8aB2vRjEG2_SgMeta || {},
    component: () => import("/opt/build/repo/pages/system/not-found.vue")
  },
  {
    name: "system-suspended",
    path: "/system/suspended",
    meta: suspended9vn7YOlpJ2727A5cw0ba9xsLsHJqebn2SlIj9PfFoq8Meta || {},
    component: () => import("/opt/build/repo/pages/system/suspended.vue")
  },
  {
    name: "terms-of-service",
    path: "/terms-of-service",
    meta: terms_45of_45service98Sl0B0s_45g1s2xKjJxHo5NIQaSuNWr6QRk_45t4WriR78Meta || {},
    component: () => import("/opt/build/repo/pages/terms-of-service.vue")
  },
  {
    name: "system-maintenance",
    path: "/system/maintenance",
    meta: maintenancegwDf0ZoJ7nGu_45hZ1ONOrBBjOHBV8Y7TLzfsvNUWX8NYMeta || {},
    component: () => import("/opt/build/repo/pages/system/maintenance.vue")
  }
]